module.exports = __webpack_public_path__ + "img/classic.3f46bd91.png";